import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LeadsContext from '../../providers/Leads';
import { Button } from 'ncoded-component-library';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import Counter from 'components/Counter';
import { COUNTER_VARIANTS } from 'components/Counter/Counter.component';
import { SIZE } from 'models/Size';

import './ShowInactiveLeads.styles.scss';

type ShowInactiveLeadsProps = {
  className?: string;
};

const ShowInactiveLeads: React.FC<ShowInactiveLeadsProps> = (props) => {
  const { className } = props;

  const {
    showInactiveLeads,
    numberOfWaitlistedGridLeads,
    numberOfWaitlistedGridUnreadMessagesNotes,
    numberOfWaitlistedGridUnrepliedMessagesNotes,
    setShowInactiveLeads,
  } = useContext(LeadsContext);

  const classes = classNames('show-inactive-leads', className);

  const { t } = useTranslation();

  if (!numberOfWaitlistedGridLeads) return null;

  return (
    <div className={classes}>
      <Button
        className={classNames({ open: showInactiveLeads })}
        variant="link"
        iconPosition="right"
        icon={ChevrondownIcon}
        onClick={() => setShowInactiveLeads((old) => !old)}
      >
        {t(showInactiveLeads ? 'hideInactiveLeads' : 'showInactiveLeads', {
          count: numberOfWaitlistedGridLeads,
        })}
      </Button>

      {!!numberOfWaitlistedGridUnreadMessagesNotes && (
        <Counter
          size={SIZE.SMALL}
          count={numberOfWaitlistedGridUnreadMessagesNotes}
        />
      )}

      {!!numberOfWaitlistedGridUnrepliedMessagesNotes && (
        <Counter
          size={SIZE.SMALL}
          variant={COUNTER_VARIANTS.SILVER}
          count={numberOfWaitlistedGridUnrepliedMessagesNotes}
        />
      )}
    </div>
  );
};

export default ShowInactiveLeads;
